import { ISearchAndDiscovery } from '../../../models/interfaces/searchAndDiscovery/iSearchAndDiscovery';
import { SearchAndDiscovery } from '../../../models/classes/searchAndDiscovery/searchAndDiscovery';

export default class State {

  public profile: ISearchAndDiscovery = new SearchAndDiscovery(); 
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/searchAndDiscovery/state.ts